import React from 'react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import '../cart-page.css';

const CartPage: React.FC = () => {
  const { cart, removeFromCart, updateHours, clearCart } = useCart();

  const handleUpdateHours = (employeeId: string, e: React.ChangeEvent<HTMLInputElement>) => {
    const hours = parseInt(e.target.value);
    if (hours > 0) {
      updateHours(employeeId, hours);
    }
  };

  const handleCheckout = () => {
    alert(`Checkout completed! Monthly subscription: $${(cart.items.reduce((sum, item) => sum + (20 * item.hours), 0)).toFixed(2)}`);
    clearCart();
  };

  return (
    <div className="cart-page">
      <h1>Your Shopping Cart</h1>

      {cart.items.length === 0 ? (
        <div className="empty-cart-page">
          <p>Your cart is empty</p>
          <Link to="/employees" className="continue-shopping">
            Browse Digital Employees
          </Link>
        </div>
      ) : (
        <>
          <div className="cart-items-container">
            <div className="cart-header-row">
              <div className="cart-header-employee">Digital Employee</div>
              <div className="cart-header-hours">Seats</div>
              <div className="cart-header-subtotal">Monthly Cost</div>
              <div className="cart-header-actions">Actions</div>
            </div>

            {cart.items.map(item => (
              <div key={item.employee.id} className="cart-row">
                <div className="cart-employee">
                  <img src={item.employee.avatar} alt={item.employee.name} className="cart-avatar" />
                  <div className="cart-employee-details">
                    <h3>{item.employee.name}</h3>
                    <p className="cart-employee-skills">
                      {item.employee.skills.slice(0, 2).join(', ')}
                      {item.employee.skills.length > 2 && '...'}
                    </p>
                  </div>
                </div>

                <div className="cart-hours">
                  <input
                    type="number"
                    min="1"
                    value={item.hours}
                    onChange={(e) => handleUpdateHours(item.employee.id, e)}
                    className="hours-input"
                    aria-label="Number of seats"
                  />
                </div>

                <div className="cart-subtotal">
                  ${(20 * item.hours).toFixed(2)}/month
                </div>

                <div className="cart-actions">
                  <button
                    onClick={() => removeFromCart(item.employee.id)}
                    className="remove-from-cart"
                    aria-label={`Remove ${item.employee.name} from cart`}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <div className="cart-total">
              <span>Total:</span>
              <span className="total-amount">${(cart.items.reduce((sum, item) => sum + (20 * item.hours), 0)).toFixed(2)}/month</span>
            </div>

            <div className="cart-actions-container">
              <button onClick={clearCart} className="clear-cart-button">
                Clear Cart
              </button>
              <button onClick={handleCheckout} className="checkout-button">
                Proceed to Checkout
              </button>
            </div>
          </div>

          <Link to="/employees" className="continue-shopping">
            Continue Shopping
          </Link>
        </>
      )}
    </div>
  );
};

export default CartPage;
